/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, NgModel, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import moment, { Moment } from 'moment';
import { MapPreviewOptions, Provider, Type } from '../location-preview/location-preview.interface';
import { Subscription } from 'rxjs';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { MapsService } from 'app/modules/maps/maps.service';
import { RouteFormOptions } from './route-form.types';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { HotToastService } from '@ngneat/hot-toast';
import { PickerOptions, PickerSelectDisableOptions, PickerSelectOptions } from '../data-picker/data-picker.interface';
import { DataPickerService } from 'app/core/services/data_picker/data_picker.service';
import { ZuperDrawerService } from '@zuper/components/zuper-drawer';
import _ from 'lodash';


@Component({
  selector: 'app-route-form',
  templateUrl: './route-form.component.html',
  styleUrls: ['./route-form.component.scss']
})
export class RouteFormComponent implements OnInit, OnDestroy, OnChanges {

  @ViewChild('modeSelect') modeSelect;
  @ViewChild('optimisationSelect') optimisationSelect;
  @Input() options: RouteFormOptions;
  @Input() date: any;
  @Input() data?: any;
  @Input() openPicker: boolean;
  @Input() drawerName: string = 'routeForm';
  @Input() showRouteAlert?: boolean = false;
  @Input() timezone?: string = this.utilityService.timeZone;
  @Input() parentModule?: string;
  @Output() actionComplete: EventEmitter<any> = new EventEmitter();

  currentFormState: 'PRIMARY' | 'REORDER' = 'PRIMARY';
  dateFormat: any;
  showMeridian: boolean;
  preference: any;
  routeTitle = new UntypedFormControl('', [Validators.required]);
  color = new UntypedFormControl('#3498DB', [Validators.required]);
  transportMode = new UntypedFormControl('CAR', [Validators.required]);
  routeOptimisation = new UntypedFormControl('FASTEST', [Validators.required]);
  startLocationStreet = new UntypedFormControl('', [Validators.required]);
  startLocationName = new UntypedFormControl('');
  startLocation = {name: '', street: ''};
  endLocation = {name: '', street: ''};
  startLocationGeoCords = [];
  endLocationStreet = new UntypedFormControl('');
  endLocationName = new UntypedFormControl('');
  endLocationGeoCords = [];
  departure = new UntypedFormControl(moment());
  duration = new UntypedFormControl('1', [Validators.pattern(/^\d+(\.\d+)?$/), Validators.min(1), Validators.max(24), Validators.required]);
  jobPickerOptions: PickerOptions = {
    header: {
      displayKey: null,
      displayName: this.utilityService.getLocaleValue('route.add.job')
    },
    position: 'right',
    mode: 'over',
    hasBackDrop: false,
    allowQuickCreate: false,
    showListCount: true,
    selectOption: PickerSelectOptions.multiSelect,
    selectionDisableBasedOn: PickerSelectDisableOptions.GEOLOCATION,
    customParams: { 'filter.is_recurrence': false },
    dataConfig: {
      routeJobFromRouteWarning: true
    }
  };
  openJob: boolean = false;
  jobs: any[] = [];
  jobPickerSubscription: Subscription;
  blockCreateRoute: boolean = false;
  timezoneDisplayName: string = '';
  routeDepartureMinDate = moment();

  //Address
  defaultAddress: any = {
    'street': '',
    'city': '',
    'latitude': 0,
    'longitude': 0
  };
  currentStartLocation: any = {...this.defaultAddress};
  startLocationSubscription: Subscription;
  mapOptions: MapPreviewOptions = {
    module: '',
    moduleUid: '',
    coords: [],
    width: 0,
    height: 0,
    zoom: 0,
    provider: Provider.GOOGLE,
    type: Type.IMAGE
  };
  showLocation: boolean;
  currentEndLocation: any = {...this.defaultAddress};
  mapEndOptions: MapPreviewOptions = {
    module: '',
    moduleUid: '',
    coords: [],
    width: 0,
    height: 0,
    zoom: 0,
    provider: Provider.GOOGLE,
    type: Type.IMAGE
  };
  showEndLocation: boolean;
  endLocationSubscription: Subscription;

  transportModeObj = {
    'CAR': 'route.choose_mode_of_transport.car_semi_truck',
    'TRUCK': 'route.choose_mode_of_transport.truck',
    'PEDESTRIAN': 'route.choose_mode_of_transport.pedestrian'
  };
  routeOptimisationObj = {
    'FASTEST': 'route.fastest_travel_time',
    'SHORTEST': 'route.shortest_distance'
  };
  constructor(
    private _localStorageService: LocalStorageService,
    private _mapService: MapsService,
    private _dataCollectorService: DataCollectorService,
    private _toast: HotToastService,
    private _zuperDrawerService: ZuperDrawerService,
    private _datapickerService: DataPickerService,
    public utilityService: UtilityService
  ) { }

  drawerOpenedChanged(event: any): void {
    if(!event){
      this.openJob = false;
      if(this.jobPickerSubscription?.unsubscribe){
        this.jobPickerSubscription?.unsubscribe();
      }
    }
  }

  onReorderChange(event: any): void {
    this.jobs = [...event];
    this.blockCreateRoute = this.checkJobInExsitingRoute();

  }

  toggleJob(): void {
    // this.openJob = false;
    // setTimeout(()=>{
      this.openJob = true;
    this.jobPickerOptions.dataConfig = { ...this.jobPickerOptions.dataConfig, routeUid: this.data?.route_uid };
    // });
    this.jobPickerSubscription = this._datapickerService.onInit.subscribe(
      (res: any) => {
        this.jobs = res;
        this.openJob = false;
        this.blockCreateRoute = this.checkJobInExsitingRoute();
      }
    );
  }

  checkJobInExsitingRoute(): boolean {
    let isJobInExistingRoute: boolean = false;
    if(this.jobs && this.jobs.length && this.options?.state !== 'edit') {
      this.jobs.forEach((job) => {
        if(job?.route?.route_uid) {
          isJobInExistingRoute = true;
        }
      });
    }
    return isJobInExistingRoute;
  }

  openMode(): void {
    setTimeout(()=>{
      this.modeSelect.open();
    });
  }

  openOptimisation(): void {
    setTimeout(()=>{
      this.optimisationSelect.open();
    });
  }

  setTime(picker: any): void {
    picker._selected = this.departure.value;
  }

  closeDrawer(): void {
    this.clearForm();
    this.openPicker = false;
    if(this.openPicker){
      this._zuperDrawerService.getComponent(this.drawerName).open();
    }else{
      this._zuperDrawerService.getComponent(this.drawerName).close();
    }
    this.actionComplete.emit({
      state: this.options?.state,
      completed: false
    });
  }

  hasTitleError(): string {
    if(this.routeTitle.touched){
      if(this.routeTitle?.errors?.required){
        return 'text.field_is_required';
      }
    }
  }


  hasDurationError(): string{
    if(this.duration.invalid){
        if(this.duration.errors.pattern){
          return 'field.pattern.number.error.message';
        }else if(this.duration.errors.max || this.duration.errors.min){
          return 'route.hours.error';
        }else if(this.duration.errors.required){
          return 'text.field_is_required';
        }
    }
    return '';
  }

  getAddressFormGroup(): UntypedFormGroup {
    return new UntypedFormGroup({
      'firstName': new UntypedFormControl(''),
      'lastName': new UntypedFormControl(''),
      'email': new UntypedFormControl('', Validators.email),
      'phone': new UntypedFormControl(''),
      'street': new UntypedFormControl('', Validators.required),
      'landmark': new UntypedFormControl(''),
      'city': new UntypedFormControl('', Validators.required),
      'state': new UntypedFormControl(''),
      'latitude': new UntypedFormControl(''),
      'longitude': new UntypedFormControl(''),
      'country': new UntypedFormControl(''),
      'zipcode': new UntypedFormControl('')
    });
  }

  showStartLocationError(): boolean {
    if(this.startLocationStreet?.touched && this.startLocationStreet?.invalid){
      return true;
    }else{
      return false;
    }
  }

  removeLocation(group: UntypedFormGroup, groupName: string): void {
    if(group?.reset){
      group.reset(this.defaultAddress);
      if(groupName === 'startLocation'){
        this.currentStartLocation = this.defaultAddress;
        this.showLocation = false;
      }else{
        this.currentEndLocation = this.defaultAddress;
        this.showEndLocation = false;
      }
    }
  }

  dataPickerEventHandler(event: any): void {
    if (event.drawerClosed) {
      this.openJob = false;
      if(this.jobPickerSubscription?.unsubscribe){
        this.jobPickerSubscription.unsubscribe();
      }
    }
  }

  getPickerFilter(): any {
    return [...this.jobs];
  }

  initReorder(): void {
    if(this.checkValidity()){
      return;
    }else{
      this.currentFormState = 'REORDER';
    }
  }

  checkValidity(): boolean {
    this.routeTitle.markAllAsTouched();
    this.startLocationStreet.markAllAsTouched();
    this.departure.markAsTouched();
    if(this.routeTitle.invalid || !this.startLocationGeoCords?.length || this.duration.invalid || this.departure.invalid){
      return true;
    }else{
      return false;
    }
  }

  getFormValue(): void {
    if(this.checkValidity()){
      return;
    }
    const payload = {
      'route_name': this.routeTitle.value,
      'departure': moment.tz(moment(this.departure.value).format('YYYY-MM-DD HH:mm:ss'), this.timezone).utc().format('YYYY-MM-DD HH:mm:ss'),
      'route_type': this.routeOptimisation.value,
      'transport_mode': this.transportMode.value,
      'duration': +this.duration.value,
      'color': this.color.value,
      'start_location': {
        'name': this.startLocation.name || '',
        'street': this.startLocation.street || '',
        'geo_cords': this.startLocationGeoCords
      }
    };
    if(this.endLocationGeoCords?.length){
      payload['end_location'] = {
        'name': this.endLocation.name || '',
        'street': this.endLocation.street || '',
        'geo_cords': this.endLocationGeoCords
    };
    }
    if (this.jobs?.length > 0 && this.options?.state !== 'clone') {
      payload['jobs'] = this.jobs.map((job: any) => ({'job': job?.job_uid}));
      payload['jobs'] = [];
      this.jobs.forEach((job: any) => {
        const data = {
            'job_uid': job?.job_uid
        };
        if(job?.customer_address?.geo_cordinates?.length > 0) {
          data['geo_cords'] = job.customer_address.geo_cordinates;
          payload['jobs'].push(data);
        }else if(job?.geo_cords?.lat && job?.geo_cords?.lng){
          data['geo_cords'] = [job?.geo_cords?.lat, job?.geo_cords?.lng];
          payload['jobs'].push(data);
        }
      });
    }else if(this.options?.state === 'edit'){
      payload['jobs'] = [];
    }
    const submit = {
      action: (this.options.state === 'edit') ? 'putData' : 'postData',
      url: (this.options?.state === 'edit') ? this._mapService.mapsAPi.getRoutes +`/${this.data?.route_uid}` : this._mapService.mapsAPi.getRoutes,
      load: (this.options?.state === 'edit') ? this.utilityService.getLocaleValue('content.route_being_updated') : this.utilityService.getLocaleValue('loader.create.route')
     };
     if(this.options?.state === 'clone'){
      submit['url'] = this._mapService.mapsAPi.getRoutes +`/${this.data?.route_uid}/clone`;
     }
     const loader = this._toast.loading(submit['load']);
    this._dataCollectorService[submit['action']](submit['url'], payload)
     .subscribe((res: any) => {
      this._toast.success(res?.message);
      this.clearForm();
      this.openPicker = false;
      if(this.openPicker){
        this._zuperDrawerService.getComponent(this.drawerName).open();
      }else{
        this._zuperDrawerService.getComponent(this.drawerName).close();
      }
      this.actionComplete.emit({
        state: this.options?.state,
        completed: true,
        uid: res?.job_route_uid,
        data: payload
      });
      loader.close();
     }, (err: any)=> {
      loader.close();
     });
  }

  clearForm(): void {
    this.jobs = [];
    this.currentFormState = 'PRIMARY';
    this.routeTitle = new UntypedFormControl('', [Validators.required]);
    this.color = new UntypedFormControl('#3498DB', [Validators.required]);
    this.transportMode = new UntypedFormControl('CAR', [Validators.required]);
    this.routeOptimisation = new UntypedFormControl('FASTEST', [Validators.required]);
    this.startLocationStreet = new UntypedFormControl('', [Validators.required]);
    this.startLocationName = new UntypedFormControl('');
    this.startLocation = { name: '', street: '' };
    this.startLocationGeoCords = [];
    this.showLocation = false;
    this.showEndLocation = false;
    this.endLocationStreet = new UntypedFormControl('');
    this.endLocationName = new UntypedFormControl('');
    this.endLocation = { name: '', street: '' };
    this.endLocationGeoCords = [];
    this.departure.setValue(moment());
    this.duration = new UntypedFormControl('1', [Validators.pattern(/^\d+(\.\d+)?$/), Validators.min(1), Validators.max(24), Validators.required]);
    this.departure.reset();
  }

  ngOnDestroy(): void {
    if(this.jobPickerSubscription?.unsubscribe){
      this.jobPickerSubscription.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if('date' in changes){
      if(this.options?.state === 'new'){
        this.departure.setValue(moment());
      }
    }
    if('openPicker' in changes){
      this.openPicker = changes.openPicker.currentValue;
      if(this.openPicker){
        this._zuperDrawerService.getComponent(this.drawerName).open();
        if(this.parentModule === 'dispatch' && this.timezone){
          this.timezoneDisplayName = this.utilityService.getTimezoneDisplayName(this.timezone);
        }
        if (this.options.state === 'new') {
          const today = moment();
          this.departure.setValue(today);
          this.updateDepartureMinDate(today);
        }
      }else{
        const drawer = this._zuperDrawerService.getComponent(this.drawerName);
        if(drawer){
          drawer.close();
        }
      }
    }
    if('options' in changes){
      this.options = changes.options.currentValue;
    }
    if('data' in changes) {
      if(this.data){
        if(this.data?.jobs?.length > 0){
          this.jobs = this.data?.jobs.map((job: any) => ({...job?.job, 'geo_cords': job?.geo_cords}));
        }else{
          this.jobs = [];
        }
        this.openJob = false;
        this.currentFormState = 'PRIMARY';
        this.routeTitle = new UntypedFormControl(this.data?.route_name, [Validators.required]);
        this.color = new UntypedFormControl(this.data?.color || '#3498DB', [Validators.required]);
        this.transportMode = new UntypedFormControl(this.data?.transport_mode || 'CAR', [Validators.required]);
        this.routeOptimisation = new UntypedFormControl(this.data?.route_type || 'FASTEST', [Validators.required]);
        if(this.data?.start_location?.geo_cords?.length){
          const startLocationAddress = _.compact([this.data?.start_location?.street, this.data?.start_location?.name]).join(', ');
          this.showLocation = false;
          this.startLocationStreet.setValue(startLocationAddress);
          this.startLocationName.setValue(this?.data?.start_location?.name);
          this.startLocation.name = this?.data?.start_location?.name;
          this.startLocation.street = this?.data?.start_location?.street;
          this.startLocationGeoCords = this?.data?.start_location?.geo_cords;
          this.mapOptions = {
            module: '',
            moduleUid: '',
            coords: this?.data?.start_location?.geo_cords,
            extraClass: 'w-full',
            width: 300,
            height: 200,
            zoom: 19,
            provider: Provider.GOOGLE,
            type: Type.IMAGE
          };
          setTimeout(()=>{
            this.showLocation = true;
          });
        }
        if(this.data?.end_location?.geo_cords?.length){
          const endLocationAddress = _.compact([this.data?.end_location?.street, this.data?.end_location?.name]).join(', ');
          this.showEndLocation = false;
          this.endLocationStreet.setValue(endLocationAddress);
          this.endLocationName.setValue(this?.data?.end_location?.name);
          this.endLocation.name = this?.data?.end_location?.name;
          this.endLocation.street = this?.data?.end_location?.street;
          this.endLocationGeoCords = this?.data?.end_location?.geo_cords;
          this.mapEndOptions = {
            module: '',
            moduleUid: '',
            coords: this?.data?.end_location?.geo_cords,
            extraClass: 'w-full',
            width: 300,
            height: 200,
            zoom: 19,
            provider: Provider.GOOGLE,
            type: Type.IMAGE
          };
          setTimeout(()=>{
            this.showEndLocation = true;
          });
        }
        const today = moment();
        if(this.data?.departure){
          this.departure.setValue(this.data?.departure);

        }else{
          this.departure.setValue(today);
        }
        this.updateDepartureMinDate(today);
        this.blockCreateRoute = this.checkJobInExsitingRoute();
        this.duration = new UntypedFormControl(this.data?.duration || 1, [Validators.pattern(/^\d+(\.\d+)?$/), Validators.min(1), Validators.max(24), Validators.required]);
      }else if(this.data === null){
        this.clearForm();
      }
    }
  }

  updateDepartureMinDate(newMinDate: moment.Moment) {
    if(!this.utilityService.companyConfig?.jobs?.['departure_in_past']) {
      this.departure.setValidators([this.minDateValidator(newMinDate)]);
      this.departure.updateValueAndValidity();
      this.routeDepartureMinDate = moment();
    }
    else {
      this.routeDepartureMinDate = null;
    }
  }

  minDateValidator(minDate: moment.Moment) {
    return (control: FormControl) =>
      control.value && moment(control.value).isBefore(minDate) ? { min: true } : null;
  }

  onAutocompleteSelected(event: any): void {
    const street = event?.address?.street;
    const city = event?.address?.city;
    if(street){
      this.startLocationStreet.setValue(street);
      this.startLocation.street = street;
    }
    if(city){
      this.startLocationName.setValue(city);
      this.startLocation.name = city;
    }
    if(event?.address?.geoLocation?.latitude && event?.address?.geoLocation?.longitude){
      const coords = {
        lat: event?.address?.geoLocation?.latitude,
        lng: event?.address?.geoLocation?.longitude
      };
      this.showLocation = false;
        this.mapOptions = {
          module: '',
          moduleUid: '',
          coords: [coords?.lat, coords?.lng],
          extraClass: 'w-full',
          width: 300,
          height: 200,
          zoom: 19,
          provider: Provider.GOOGLE,
          type: Type.IMAGE
        };
        this.startLocationGeoCords = [coords?.lat, coords?.lng];
        setTimeout(()=>{
          if(coords?.lat && coords?.lng){
            this.showLocation = true;
            // this.startModeChange();
          }
        }, 100);
    }
  }

  startLocationChange(): void {
    if(!this.startLocationStreet?.value){
      this.startLocationGeoCords = [];
      this.showLocation = false;
        this.mapOptions = {
          module: '',
          moduleUid: '',
          coords: [0, 0],
          extraClass: 'w-full',
          width: 300,
          height: 200,
          zoom: 19,
          provider: Provider.GOOGLE,
          type: Type.IMAGE
        };
        this.startLocationGeoCords = [];
        this.startLocationName.setValue('');
        this.startLocation.name = '';
        setTimeout(()=>{
          if(this.startLocationGeoCords?.length){
            this.showLocation = true;
          }
        }, 100);
    }
  }

  onEndLocationSelected(event: any): void {
    const street = event?.address?.street;
    const city = event?.address?.city;
    if(street){
      this.endLocationStreet.setValue(street);
      this.endLocation.street = street;
    }
    if(city){
      this.endLocationName.setValue(city);
      this.endLocation.name = city;
    }
    if(event?.address?.geoLocation?.latitude && event?.address?.geoLocation?.longitude){
      const coords = {
        lat: event?.address?.geoLocation?.latitude,
        lng: event?.address?.geoLocation?.longitude
      };
      this.showEndLocation = false;
        this.mapEndOptions = {
          module: '',
          moduleUid: '',
          coords: [coords?.lat, coords?.lng],
          extraClass: 'w-full',
          width: 300,
          height: 200,
          zoom: 19,
          provider: Provider.GOOGLE,
          type: Type.IMAGE
        };
        this.endLocationGeoCords = [coords?.lat, coords?.lng];
        setTimeout(()=>{
          if(coords?.lat && coords?.lng){
            this.showEndLocation = true;
            // this.startModeChange();
          }
        }, 100);
    }
  }

  endLocationChange(): void {
    if(!this.endLocationStreet?.value){
      this.endLocationGeoCords = [];
      this.showEndLocation = false;
        this.mapEndOptions = {
          module: '',
          moduleUid: '',
          coords: [0, 0],
          extraClass: 'w-full',
          width: 300,
          height: 200,
          zoom: 19,
          provider: Provider.GOOGLE,
          type: Type.IMAGE
        };
        this.endLocationGeoCords = [];
        this.endLocationName.setValue('');
        this.endLocation.name = '';
        setTimeout(()=>{
          if(this.endLocationGeoCords?.length){
            this.showEndLocation = true;
          }
        }, 100);
    }
  }

  ngOnInit(): void {
    this.dateFormat = this.utilityService.dateTimeFormat;
    this.showMeridian = this.utilityService.showMeridian;
  }

}
